import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../Common/styles/header";
import FeaturesList from "./Tabs/FeaturesList";
import FeatureUrlLoader from "./FeatureUrlLoader";
import FeatureUrlSetter from "./FeatureUrlSetter";
import {
  a11yProps,
  CustomTabPanel,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import Permissions from "./Tabs/Permissions";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
// import LogoutContainer from "../Layout/LogoutContainer";

const Features = () => {
  const [showModal, setShowModal] = useState<string>("");
  const [type, setType] = useState("features");
  const [urlLoaded, setUrlLoaded] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions
  );
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };
  return urlLoaded ? (
    <>
      <Box
        sx={{
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        {/* <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box> */}
      </Box>
      <StyledHeader>
        <Box sx={HeaderLeftContent}>
          <Typography fontWeight="medium" color="text.primary">
            Features
          </Typography>
        </Box>

        <Box sx={HeaderRightContent}>
          {type === "features" && canEdit && (
            <Box>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setShowModal("feature")}
              >
                New Feature
              </Button>
            </Box>
          )}
          {/* {type === "permissions" && canEdit && (
            <Box>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setShowModal("permissions")}
              >
                Add Permission
              </Button>
            </Box>
          )} */}
        </Box>
      </StyledHeader>
      <Box sx={{ borderTop: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={type} onChange={handleChange}>
          <StyledTab label="Features" value="features" {...a11yProps(0)} />
          <StyledTab
            label="Permissions"
            value="permissions"
            {...a11yProps(1)}
          />
        </StyledTabs>
      </Box>
      <Box>
        <Box sx={{ height: "calc(100vh - 189px)", overflow: "auto" }}>
          <MainTabPanel value={type} index={"features"}>
            <FeaturesList
              type={type}
              showModal={showModal}
              setShowModal={setShowModal}
              canEdit={canEdit}
            />
          </MainTabPanel>

          <CustomTabPanel value={type} index={"permissions"}>
            <Permissions
              type={type}
              showModal={showModal}
              setShowModal={setShowModal}
              searchText={searchText}
              setSearchText={setSearchText}
              canEdit={canEdit}
            />
          </CustomTabPanel>
        </Box>
      </Box>
      <FeatureUrlSetter type={type} searchText={searchText} />
    </>
  ) : (
    <FeatureUrlLoader
      setType={setType}
      setSearchText={setSearchText}
      setUrlLoaded={setUrlLoaded}
    />
  );
};

export default Features;
